import { render } from "./ModalTarefa.vue?vue&type=template&id=6b42e0e0&scoped=true"
import script from "./ModalTarefa.vue?vue&type=script&lang=js"
export * from "./ModalTarefa.vue?vue&type=script&lang=js"

import "./ModalTarefa.vue?vue&type=style&index=0&id=6b42e0e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\vinicius.martins\\Desktop\\pasta\\teste\\projeto-automacao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b42e0e0"]])

export default __exports__